import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Mekanics Manager — Logo de marca.
 *
 * Sirve los ASSETS REALES de `public/assets/branding/` (no recreaciones).
 * Cada variante apunta al archivo oficial correspondiente:
 *
 *   <mk-logo variant="horizontal" [size]="40" />   navbar / encabezados (fondo claro)
 *   <mk-logo variant="isotipo"   [size]="28" />    espacios reducidos (caja navy, sirve en cualquier fondo)
 *   <mk-logo variant="principal" [size]="180" />   login / bienvenida (fondo claro)
 *   <mk-logo variant="banner"    [size]="120" />    franjas de marca (navy autocontenido)
 *
 * `size` define el ALTO en px (el ancho se ajusta por relación de aspecto;
 * el isotipo es cuadrado).
 */
@Component({
  selector: 'mk-logo',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <img [src]="src" [alt]="alt" [style.height.px]="size"
         style="width:auto;display:block;max-width:100%" />
  `,
})
export class LogoComponent {
  @Input() variant: 'principal' | 'horizontal' | 'isotipo' | 'banner' = 'horizontal';
  /** Alto en px. */
  @Input() size = 36;

  private static readonly FILES: Record<string, string> = {
    principal: 'mekanics_logo_principal.svg',
    horizontal: 'mekanics_logo_horizontal.svg',
    isotipo: 'mekanics_icono_app.svg',
    banner: 'mekanics_banner_web.svg',
  };

  get src(): string {
    return `/assets/branding/${LogoComponent.FILES[this.variant]}`;
  }

  get alt(): string {
    return this.variant === 'isotipo' ? 'Mekanics' : 'Mekanics Manager';
  }
}
